import {
  RESET_TRANSFER_CHAT,
  API_ERROR,
  GET_TRANSFER_CHAT,
  SET_TRANSFER_CHAT,
  TRANSFER_CHAT,
  TRANSFERED_CHAT,
} from "./actionTypes";

export const resetTransferChats = (reset) => {
  return {
    type: RESET_TRANSFER_CHAT,
    payload: reset,
  };
};

export const loadTransferChats = (data) => {
  return {
    type: SET_TRANSFER_CHAT,
    payload: data,
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const getTransferChats = (id) => {
  return {
    type: GET_TRANSFER_CHAT,
    payload: { id },
  };
};
export const setTransferChats = (data) => {
  return {
    type: SET_TRANSFER_CHAT,
    payload: data,
  };
};

export const transferChat = (data, type, id) => {
  return {
    type: TRANSFER_CHAT,
    payload: { data, type, id },
  };
};

export const transferedChat = (data) => {
  return {
    type: TRANSFERED_CHAT,
    payload: data,
  };
};
